import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/home.vue'
import About from '@/view/about.vue'
import ContactUs from '@/view/contact_us.vue'
import Tracking from '@/view/tracking.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Tracking',
      component: Tracking
    },
    {
      path: '/About',
      name: 'About',
      component: About
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/Tracking',
      name: 'Tracking',
      component: Tracking
    }
  ],
  scrollBehavior(to, from, savedPosition) { //to top
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js